module.exports = __webpack_public_path__ + "img/car.a73a0764.png";